export enum shelfKeys {
    channelCards = 'channelCards',
    newShowsCards = 'newShowsCards',
    newMoviesCards = 'newMoviesCards',
    recommendedShowsCards = 'recommendedShowsCards',
    recommendedMoviesCards = 'recommendedMoviesCards',
    vodContinueWatchingCards = 'vodContinueWatchingCards',
    mostPopularCards = 'mostPopularCards',
    newReleasesCards = 'newReleasesCards',
    filtersCards = 'filtersCards',
    recentChannelsCards = 'recentChannelsCards',
    moviesCards = 'moviesCards',
    sportsCards = 'sportsCards',
    kidsCards = 'kidsCards',
    newsCards = 'newsCards',
    continueWatchingCards = 'continueWatchingCards',
    recentlyOnDemandCards = 'recentlyOnDemandCards',
    watchAgainCards = 'watchAgainCards',
    trendsCards = 'trendsCards',
    tabsGenresCards = 'tabsGenresCards',
    programsCards = 'programsCards',
    episodesCards = 'episodesCards',
    castCards = 'castCards',
    relatedCards = 'relatedCards',
    searchResultChannelsCards = 'searchResultChannelsCards',
    searchResultLiveCards = 'searchResultLiveCards',
    searchResultMoviesCards = 'searchResultMoviesCards',
    searchResultShowsCards = 'searchResultShowsCards',
    searchResultCreditsCards = 'searchResultCreditsCards',
    favouritesChannelsCards = 'favouritesChannelsCards',
    favouritesOnDemandsCards = 'favouritesOnDemandsCards',
    favouritesLiveTvCards = 'favouritesLiveTvCards',
    vodWatchAgainCards = 'vodWatchAgainCards',
    genresCards = 'genresCards',
    subChannelCards = 'subChannelCards',
    playerChannelsCards = 'player-channels',
    playerEpisodesCards = 'player-episodes',
    playerRelatedCards = 'playerRelatedCards',
    playerLinesId = 'player-lines',
    olympicsCards = 'olympicsCards',
    liveSeries = 'liveSeries',
    showAll = 'showAll',
    showsCards = 'showsCards',
};
